import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { setPortal } from 'modules/portal';
import { showSuccessSnackbar } from 'modules/snackbar';
import { shoppingCustomized } from 'constants/resources/commonCustomize';

import MainTemplate from 'pages/templates/MainTemplate';

import MbTabs from 'components/organisms/MbTabs';

import Statistics from './Statistics';
import FilterIpStatistics from './FilterIpStatistics';
import RateStatistics from './RateStatistics';
import AvgRateStatistics from './AvgStatistics';
import ClickList from './ClickList';

const AbusingList = () => {
  const dispatch = useDispatch();
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  const customized = {
    ...shoppingCustomized,
    URL: { merged: true },
    ADVER_ID: {
      makeBody: (rowObj) => {
        return rowObj['CORP_NAME'] !== 'total' && rowObj['ADVER_ID'];
      },
    },
  };

  return (
    <MainTemplate>
      <MbTabs
        name="AbusingList"
        tabMenuList={tabList()}
        tabs={{
          '/report/abusing/ipreport': {
            tabComponent: (
              <Statistics handleClickSnackbar={handleClickSnackbar} />
            ),
          },
          '/report/abusing/filteripreport': {
            tabComponent: (
              <FilterIpStatistics handleClickSnackbar={handleClickSnackbar} />
            ),
          },
          '/report/abusing/ratereport': {
            tabComponent: (
              <RateStatistics
                customized={customized}
                handlePortalUrl={handlePortalUrl}
              />
            ),
          },
          '/report/abusing/avgreport': {
            tabComponent: (
              <AvgRateStatistics
                customized={customized}
                handlePortalUrl={handlePortalUrl}
              />
            ),
          },
          '/report/abusing/ipreport/click': {
            tabComponent: <ClickList />,
            isPop: 1,
          },
        }}
      />
    </MainTemplate>
  );
};

export default AbusingList;
